<template>
  <div>
    <div v-if="loading" class="step-loading"></div>
    <v-card flat class="wgk-card wgk-card-transparent">


      <v-container fluid class="wgk-dehn-bgcolor__light" style="border-radius: 0;">
        <v-row>
          <v-col class="wgk-result-counter-container">
            {{ wgkResultProductsLocal.amountProducts }} Produkt<template v-if="wgkResultProductsLocal.amountProducts > 1">e</template>
            <span v-if="wgkResultProductsLocal.amountRecommended > 0" class="wgk-result-counter-recommendation">/ {{ wgkResultProductsLocal.amountRecommended }} Empfehlung<template v-if="wgkResultProductsLocal.amountRecommended > 1">en</template></span>
            <span v-if="wgkResultProductsLocal.amountRequired > 0" class="wgk-result-counter-required"> / {{ wgkResultProductsLocal.amountRequired }} Erforderlich</span>
          </v-col>
        </v-row>
      </v-container>

      <template v-for="(item, index) in wgkResultProductsLocal.products">
        <v-container
          fluid :key="index"
          class="wgk-result-item mb-4"
          v-bind:class="{ active: item.active }"
        >
          <v-row>
            <v-col order-sm="2" cols="10" sm="8" md="9" class="flex-grow-0 flex-shrink-1">
              <breadcrumb
                :items="item.filterApplied"
              >
              </breadcrumb>
              <span class="wgk-product-name text-h4 text-md-h2">{{ item.name }} </span><br/>
              <span class="wgk-product-number text-h6 text-md-h5" >{{ item.number }} / {{ item.type }}</span>
              <div
                class="wgk-product-flag required mt-2 mb-2"
                v-if="item.required"
              >
                <v-btn
                  v-if="item.required"
                  class="mr-2"
                  fab
                  x-small
                  depressed
                  disabled
                  color="primary"
                >
                  <v-icon small>
                    mdi-alert
                  </v-icon>
                </v-btn>
                <span>{{ item.featureText }}</span>
              </div>
              <div
                class="wgk-product-flag recommended mt-2 mb-2"
                v-if="item.recommended"
              >
                <v-btn
                  v-if="item.recommended"
                  class="mr-2"
                  fab
                  x-small
                  depressed
                  disabled
                  color="primary"
                >
                  <v-icon small>
                    mdi-thumb-up
                  </v-icon>
                </v-btn>
                <span>{{ item.featureText }}</span>
              </div>
              <div v-if="$vuetify.breakpoint.smAndUp" class="wgk-product-description" v-html="item.description"></div>
              <!--
              <template v-if="$vuetify.breakpoint.smAndUp && item.featureText">
                <step-result-product-notice
                  prefix="desktop-"
                  :sourceId="item.sourceId"
                  :featureText="item.description"
                ></step-result-product-notice>
              </template>
              -->
            </v-col>
            <v-col order-sm="3" cols="2" sm="1" md="1" class="flex-grow-1">
              <v-checkbox
                class="wgk-product-checkbox shrink mr-0 mt-0 float-right"
                style="transform: scale(1.25);"
                off-icon="mdi-checkbox-blank-circle-outline"
                on-icon="mdi-checkbox-marked-circle-outline"
                v-model="item.active"
              ></v-checkbox>
            </v-col>
            <v-col
              order-sm="1"
              cols="11" sm="3" md="2"
              class="mt-2 mb-2 mt-sm-0 mb-sm-0"
            >
              <div class="wgk-result-image">
                <vue-responsive-image
                  :image-url="thumborProductView + thumborDomainOnly + item.images[0].url"
                  :image-ratio="1/1"
                  :show-error-image="true"
                  :width-on-screen="20"
                  :width-on-screen-tablet="50"
                  :width-on-screen-smartphone="50"
                  :alt="item.name"
                ></vue-responsive-image>
              </div>
            </v-col>


          </v-row>

          <v-row v-if="$vuetify.breakpoint.xsOnly && item.description">
            <v-col cols="12">
              <step-result-product-notice
                prefix="mobile-"
                :sourceId="item.sourceId"
                :featureText="item.description"
              ></step-result-product-notice>
            </v-col>
          </v-row>

          <v-row
            class="wgk-result-actions"
          >
            <v-col offset-sm="2">
              <div class="d-flex justify-end">
                <div class="wgk-result-action-btn mr-6">
                  <span class="text-h6 mr-sm-2">Details</span>
                  <v-btn
                    :href="item.url"
                    target="_blank"
                    fab
                    small
                    depressed
                    color="#EBEBEB"
                  >
                    <v-icon
                      small
                    >
                      mdi-format-align-left
                    </v-icon>
                  </v-btn>
                </div>
                <div class="wgk-result-action-btn mr-6">
                  <span class="text-h6 mr-sm-2">Merkliste</span>
                  <v-btn
                    :disabled="!item.active"
                    @click.stop="singleAddToNotepad(item.sourceId, item.number, item.amount)"
                    fab
                    small
                    depressed
                    color="primary"
                  >
                    <v-icon
                      small
                    >
                      mdi-plus
                    </v-icon>
                  </v-btn>
                </div>
                <div class="wgk-result-action-btn align-self-end">
                  <span class="text-h6 mr-sm-2">Menge</span>
                  <v-text-field
                    :disabled="!item.active"
                    v-model="item.amount"
                    style="min-width:100px;max-width: 120px"
                    class="wgk-result-action-amount shrink mt-0 pt-0"
                    :label="item.vpeUnit"
                    value="1"
                    :suffix="item.vpeUnit"
                    min="1"
                    hide-details="auto"
                    type="number"
                    single-line
                    outlined
                    dense
                    rounded
                  ></v-text-field>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </template>

      <dialog-notepad
        v-model="showNotepadDialogSingle"
        :notepadUrl="wgkResultProductsLocal.notepadUrlSelf"
        :notepadCurrentArticle="notepadCurrentArticle"
        :notepadSelectedArticles="selectedProductsNumbers"
      ></dialog-notepad>

      <dialog-notepad
        v-model="showNotepadDialogMulti"
        :notepadUrl="wgkResultProductsLocal.notepadUrlSelf"
        :notepadSelectedArticles="selectedProductsNumbers.split(',').join(', ')"
        :notepadMulti="showNotepadDialogMulti"
      ></dialog-notepad>

      <dialog-elbridge
        v-model="showElbridgeDialog"
        :products="activeProducts"
        :elbridgeProducts="elbridgeProducts"
        :elbridgeConfig="wgkResultProducts.elbridgeConfiguration"
      >
      </dialog-elbridge>

    </v-card>
    <v-container fluid class="wgk-result-footer-actions">
      <v-row no-gutters class="mt-6 justify-end justify-lg-space-between">
        <v-col cols="12" lg="auto" order="3" order-lg="1" class="d-flex flex-column flex-sm-row">
          <v-btn
            :href="wgkResultProductsLocal.ebaUrl + selectedProductsSourceIds"
            @click="trackCustomAction('Download Anleitungen')"
            class="mb-4 mb-sm-0"
            color="tertiary"
            depressed
          >Anleitungen
            <v-icon
              dark
              right
            >
              mdi-arrow-down
            </v-icon>
          </v-btn>
          <v-btn
            :href="wgkResultProductsLocal.specificationUrl + selectedProductsSourceIds"
            @click="trackCustomAction('Download Datenblätter')"
            class="mb-4 mb-sm-0 ml-sm-4"
            color="tertiary"
            depressed
          >Datenblätter
            <v-icon
              dark
              right
            >
              mdi-arrow-down
            </v-icon>
          </v-btn>
          <v-btn
            :href="wgkResultProductsLocal.lvUrl + selectedProductsSourceIds"
            @click="trackCustomAction('Download LV-Texte')"
            class="mb-4 mb-sm-0 ml-sm-4"
            color="tertiary"
            depressed
          >LV-Texte
            <v-icon
              dark
              right
            >
              mdi-arrow-down
            </v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12" sm="auto" order="1" order-lg="2" class="d-flex flex-column flex-sm-row flex-md-row mb-4 mr-lg-0 mb-lg-0 text-sm-center">
          <v-btn
            @click="showElbridgeDialog=true"
            :block="$vuetify.breakpoint.xsOnly"
            color="secondary" depressed
          >Warenkorb (Elektrogroßhandel)
            <v-icon
              dark
              right
            >
              mdi-cart-outline
            </v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12" sm="auto" order="2" order-lg="3" class="d-flex flex-column flex-sm-row flex-md-row mb-4 ml-sm-4 mb-lg-0 text-sm-right">
          <v-btn
            :loading="multiNotepadLoading"
            color="primary"
            v-on:click="multiAddToNotepad"
          >
            Auswahl merken
            <v-icon
              dark
              right
            >
              mdi-checkbox-marked-circle-outline
            </v-icon>
           </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {mapGetters,mapState,mapActions} from "vuex";
import {dataLayer, DEHNTHUMBOR, DEHNTHUMBOR_DOMAIN_ONLY} from '../http-common';
import VueResponsiveImage from 'vue-responsive-image'
import DialogNotepad from "./DialogNotepad";
import DialogElbridge from "./DialogElbridge";
import StepResultProductNotice from "./StepResultProductNotice";
import axios from "axios";
import Breadcrumb from "./Breadcrumb";

export default {
  name: "StepResult",
  components: { VueResponsiveImage, DialogNotepad, StepResultProductNotice, DialogElbridge, Breadcrumb },
  data () {
    return {
      wgkResultProductsLocal: {
        products: []
      },
      articles: [{sourceId:'',amount:'2', active:true}],
      showNotepadDialogSingle: false,
      showNotepadDialogMulti: false,
      multiNotepadLoading: false,
      showElbridgeDialog: false,
      notepadCurrentArticle: {
        number: '',
        sourceId: '',
        amount: ''
      },
    }
  },
  created() {
    //console.log(this.$vuetify.breakpoint);
    if (this.wgkCurrentStep === this.lastStep) {
      this.$store.dispatch('fetchAndSetWgkResultProducts').then(() => {
        this.wgkResultProductsLocal = this.$store.state.wgkResultProducts;
      })
    }
  },
  computed: {
    ...mapGetters([
      'wgkCurrentStep',
      'wgkResultProducts'
    ]),
    ...mapState({
      loading: state => state.wgkStepResultLoading
    }),
    lastStep: function() {
      return this.$store.state.wgkSuperGroups.length + 1
    },
    thumborDomainOnly: function() {
      return DEHNTHUMBOR_DOMAIN_ONLY;
    },
    thumborDefaultView: function () {
      return DEHNTHUMBOR + '/fit-in/%width%x/filters:fill(ffffff,false):quality(98)/'
    },
    thumborProductView: function () {
      return DEHNTHUMBOR + '/fit-in/%width%x%height%/filters:fill(ffffff,false):format(jpeg):quality(98)/'
    },
    activeProducts: function () {
      return this.wgkResultProductsLocal.products.filter(function (el) {
        return el.active;
      });
    },
    elbridgeProducts: function () {
      let elbProds = this.activeProducts.map(function(obj) {
        return {
          name: obj.name.replace(/\r?\n/g, " ").trim(),
          id: obj.number,
          price: null,
          brand: 'DEHN',
          category: 'DEHNselect Wohngebaeude',
          variant: 'undefined',
          list: 'undefined',
          quantity: obj.amount,
        }
      })
      return elbProds;
    },
    selectedProductsSourceIds: function() {
      return Array.prototype.map.call(this.activeProducts, function(item) { return item.sourceId; }).join(",");
    },
    selectedProductsAmounts: function() {
      return Array.prototype.map.call(this.activeProducts, function(item) { return item.amount; }).join(",");
    },
    selectedProductsNumbers: function() {
      return Array.prototype.map.call(this.activeProducts, function(item) { return item.number; }).join(",");
    },
  },
  methods: {
    ...mapActions([
      'trackCustomAction'
    ]),
    singleAddToNotepad(sourceId, number, amount) {
      this.notepadCurrentArticle.sourceId=sourceId;
      this.notepadCurrentArticle.number=number;
      this.notepadCurrentArticle.amount=amount;
      axios
        .get(this.wgkResultProductsLocal.notepadUrlAppend + sourceId + '&quantities=' + amount )
        .then(() => {
          this.showNotepadDialogSingle=true
        })
        .catch((error) => {
          alert('Ein Fehler ist aufgetreten. Wir bitten um Entschuldigung. Bitte versuchen Sie es später noch einmal erneut.')
          console.log(error);
        })
    },
    multiAddToNotepad() {
      this.multiNotepadLoading = true;
      this.trackCustomAction('Merkzettel');
      axios
        .get(this.wgkResultProductsLocal.notepadUrlAppend + this.selectedProductsSourceIds + '&quantities=' + this.selectedProductsAmounts )
        .then(() => {
          this.multiNotepadLoading = false;
          this.showNotepadDialogMulti=true;
        })
        .catch((error) => {
          this.multiNotepadLoading = false;
          alert('Ein Fehler ist aufgetreten. Wir bitten um Entschuldigung. Bitte versuchen Sie es später noch einmal erneut.')
          console.log(error);
        })
    },
    trackElbridgeCheckout() {
      dataLayer.push({
        'event': 'checkout',
        'ecommerce': {
          'currencyCode': 'EUR',
          'checkout': {
            'actionField': {
              'step': 5
            },
            'products': this.elbridgeProducts
          }
        }
      });
    },
  },
  watch: {
    wgkCurrentStep (val) {
      if (val === this.lastStep) {
        this.$store.dispatch('fetchAndSetWgkResultProducts');
      }
    },
    showElbridgeDialog (val) {
      if(val) {
        this.trackCustomAction('Warenkorb');
        this.trackElbridgeCheckout();
      }
    },
    wgkResultProducts: {
      handler(newVal, oldVal){
        if (JSON.stringify(oldVal) !== JSON.stringify(newVal)) {
          this.wgkResultProductsLocal = this.$store.state.wgkResultProducts;
        }
      },
      deep: true
    }
  },
}
</script>

<style lang="scss">

@import '../../src/sass/variables.scss';

@import '~vuetify/src/styles/settings/_variables';

.wgk-card-transparent {
  background: none !important;
}

.wgk-result-counter-container {
  text-align: center;
  font-size: 90%;
}

.wgk-result-counter-recommendation
{
  color: $c-dehn-gray--darkest;
}

.wgk-result-counter-required
{
  color: $c-dehn-red;
}

.wgk-result-item {
  padding: 20px;
  background: $c-dehn-white;
  opacity: 0.5;
  &.active {
    opacity: 1;
  }
}

.wgk-result-image {
  //border: 1px solid #C5CACF;
  padding: 10px;
  picture, source, img {
    width: 100%;
    max-width: 100%;
    margin: 0;
  }
}

@media #{map-get($display-breakpoints, 'xs-only')} {
  .wgk-result-image {
    padding: 0;
    width: 50%;
    margin: 0 auto;
  }
}

.v-application .wgk-product-number {
  color: #B2B2B2;
  font-size:15px;
  font-family: AvenirNext, sans-serif !important;
  font-weight: normal !important;
}

.wgk-product-name {
  color:$c-dehn-red;
}

.wgk-product-description {
  color:$c-dehn-gray--darker;
}

.wgk-product-flag {

  font-size: 90%;
  .v-btn--fab.v-size--x-small {
    height: 24px;
    width: 24px;
  }
  label, span {
    vertical-align: middle;
  }
  .v-icon {
    font-size: 14px !important;
  }
  .v-btn.v-btn--disabled .v-icon {
    color: $c-dehn-white !important;
  }
  &.required {
    color:$c-dehn-red;
    .v-btn.v-btn--disabled.v-btn--has-bg {
      background-color: $c-dehn-red !important;
    }
  }
  &.recommended {
    color:$c-dehn-gray--darkest;
    .v-btn.v-btn--disabled.v-btn--has-bg {
      background-color: $c-dehn-gray--darkest !important;
    }
  }
  &.notice {
    color:$c-dehn-gray--dark;
    .v-btn.v-btn--disabled.v-btn--has-bg {
      background-color: $c-dehn-gray--dark !important;
    }
  }
}

.wgk-result-action-amount {
  display: inline-block;
}

.wgk-product-flag-text {
  color: $c-dehn-gray--darker;
}



input.featureToggle:checked + label + div { display: none; }
input.featureToggle + label:after { content: " ausblenden"; }
input.featureToggle:checked + label:after { content: " anzeigen"; }

.wgk-product-checkbox {
  .v-icon {
    font-size:24px;
  }
  .v-input--selection-controls__input {
    margin:0;
  }
}

.wgk-result-action-btn {
  > span {
    color: #B2B2B2;
  }
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .wgk-result-action-btn {
    display: table-cell;
    text-align:center;
    vertical-align: middle;
    > span {
      display: block;
      padding-bottom: 4px;
    }
  }
}

.wgk-result-footer-actions {
  .v-btn {
    height: auto !important;
    padding: 10px 16px !important;
  }
  .v-btn__content { width: 100%; white-space: normal; }
  .row  {
    background: $c-dehn-white;
    padding: 10px;
  }
}






</style>
